import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { Outlet } from "react-router-dom";
import { getFullBodyLayoutStyles } from "@components/page-layout/full-body-layout-styles";

/**
 * Describes the layout for full body pages i.e: account setting page, add credits page. Includes the header bar,
 * and the "Outlet", in which the router will inject every page content.
 */
export function FullBodyLayout(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getFullBodyLayoutStyles();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    contentWrapper,
    content
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      px: contentWrapper.px,
      pt: contentWrapper.pt,
      justifyContent: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      maxWidth: content.maxWidth
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = children ? children : <Outlet />;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Grid container={true} data-testid="CONTENT_WRAPPER" sx={t2}><Grid data-testid="CONTENT" sx={t3}>{t4}</Grid></Grid>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}